import React from "react";
import classes from "./styles.module.scss";
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';

const Pattern = `${process.env.REACT_APP_STATIC_BASE_URL}/Pattern.png`;

const RankCard = () => {
    return(
        <>
            <div className={classes.rank_card} style={{ backgroundImage: `url(${Pattern})` }}>
                <div className={classes.card}>
                    <div className={classes.card_content}>
                        <div className={classes.logo}>
                            <MilitaryTechIcon />
                        </div>
                        <div className={classes.letter}>
                            <h4>You've<br /> Ranked At</h4>
                            <p>You have done Very very well</p>
                        </div>
                        <div className={classes.rank}>
                            34
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RankCard;